export default __webpack_public_path__ + "static/media/logo_trqk_iq_indie_edition.b68e9612.svg";